<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="1" :tab="$t('tab.disqualificationOrder')" style="margin-top: -14px">
        <disqualification-destory-apply-table ref="disqualificationDestoryApplyTable" @dblclick="dblclick"/>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('tab.orderDetail')" forceRender style="margin-top: -14px">
        <disqualification-destory-apply-detail ref="disqualificationDestoryApplyDetail" @failed="failed" @success="success"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-button type="primary" @click="query">{{ $t('button.query') }}</a-button>
        <a-button type="primary" @click="reset">{{ $t('button.reset') }}</a-button>
        <a-button :disabled="approveDisabled" :loading="approveLoading" type="primary" @click="approve">{{ $t('button.destroyEntry') }}</a-button>
      </a-space>
    </a-tabs>
  </a-layout>
</template>

<script>
  import DisqualificationDestoryApplyTable from '@/views/quality_control/disqualification_manage/disqualification_destory_apply/DisqualificationDestoryApplyTable.vue'
  import DisqualificationDestoryApplyDetail from '@/views/quality_control/disqualification_manage/disqualification_destory_apply/DisqualificationDestoryApplyDetail.vue'

  export default {
    name: 'DisqualificationDestoryApply',
    components: {
      DisqualificationDestoryApplyDetail,
      DisqualificationDestoryApplyTable
    },
    data() {
      return {
        activeKey: '1',
        approveLoading: false,
        rejectLoading: false,
        approveDisabled: true,
        rejectDisabled: true
      }
    },
    watch: {
      activeKey: {
        handler(newVal) {
          if (newVal === '1') {
            this.approveDisabled = true
            this.rejectDisabled = true
          } else {
            this.approveDisabled = false
            this.rejectDisabled = false
          }
        }
      }
    },
    methods: {
      dblclick(record) {
        this.activeKey = '2'
        this.$refs.disqualificationDestoryApplyDetail.getData(record)
      },
      approve() {
        this.approveLoading = true
        this.$refs.disqualificationDestoryApplyDetail.approve()
      },
      query() {
        if (this.activeKey === '1') {
          this.$refs.disqualificationDestoryApplyTable.getData()
        } else {
          this.$refs.disqualificationDestoryApplyDetail.getData()
        }
      },
      reset() {
        this.$refs.disqualificationDestoryApplyTable.reset()
        this.$refs.disqualificationDestoryApplyDetail.clear()
      },
      success() {
        this.approveLoading = false
        this.rejectLoading = false
        this.$refs.disqualificationDestoryApplyTable.getData()
        this.$refs.disqualificationDestoryApplyDetail.clear()
      },
      failed() {
        this.approveLoading = false
        this.rejectLoading = false
      }
    }
  }
</script>
